export const LoanEditorCustomFormDrawerTestIds = {
  SAVE_BUTTON: 'loan-editor-custom-form-drawer.save-button',
  INAPPLICABLE_NOTICE: 'loan-editor-custom-form-drawer.inapplicable-notice',
};
